import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
    selector: 'shared-view-header',
    templateUrl: './view-header.component.html',
    styleUrls: ['./view-header.component.scss'],
    standalone: false
})
export class ViewHeaderComponent {
  @Input({required: true}) title!: string
  @Input() actionButtonTitle?: string
  @Output() actionButtonClicked = new EventEmitter()
}
